import React from 'react';

type DotLoaderProps = {
    /** Tailwind classes for the dot colour (default: blue) */
    className?: string;
};

/**
 * Compact three-dot pulse for inline / table-cell loading states.
 */
export default function DotLoader({ className = 'bg-blue-600 dark:bg-blue-400' }: DotLoaderProps) {
    return (
        <span className="inline-flex items-center justify-center gap-1" role="status" aria-label="Loading">
            {[0, 1, 2].map((i) => (
                <span
                    key={i}
                    className={`h-1.5 w-1.5 shrink-0 rounded-full animate-bounce ${className}`}
                    style={{ animationDelay: `${i * 0.12}s`, animationDuration: '0.55s' }}
                />
            ))}
        </span>
    );
}
